angular
  .module("ticketco/common/arena")
  //.controller('arenaItemTypesController', arenaItemTypesController)
  .component("arenaItemTypeGroups", {
    bindings: {
      groups: "<",
      trackingLinkUuid: "@",
      activeItemType: "@",
      promocode: "@",
      onItemTypeClick: "&",
    },
    templateUrl: "arenaItemTypeGroupsComponent.html",
    controller: function arenaItemTypesController() {
      var self = this;

      self.setActive = function (itemType) {
        return (self.activeItemType = itemType);
      };

      self.getActive = function () {
        return self.activeItemType;
      };

      this.$onInit = function () {
        self.activeItemType = parseFloat(self.activeItemType);

        /*self.groups = tc.dataStructure.Hash.of(self.groups)
          .filter(function (val) {
            console.log("val", val);
            return val.length > 0;
          });*/
        if (self.activeItemType) {
          self.setActive(self.activeItemType);
          self.onItemTypeClick({ $itemType: self.activeItemType });
        }
      };
    },
  });
